module.exports = "<delivery-information-form></delivery-information-form>";